var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.211,
    height: 23.203,
    viewBox: "0 0 23.211 23.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-whatsapp",
    "data-name": "Icon awesome-whatsapp",
    d: "M18.7,5.447A10.905,10.905,0,0,0,1.547,18.6L0,24.25l5.78-1.517a10.869,10.869,0,0,0,5.21,1.326h0a11.007,11.007,0,0,0,11-10.9A10.945,10.945,0,0,0,18.7,5.447Zm-2.74,9.988c-.27-.138-1.611-.8-1.861-.884s-.432-.138-.614.137-.7.884-.864,1.071-.319.206-.589.069a7.415,7.415,0,0,1-3.708-3.241c-.28-.481.28-.447.8-1.488a.5.5,0,0,0-.025-.476c-.069-.137-.614-1.478-.84-2.023s-.447-.457-.614-.467-.339-.01-.521-.01a1.009,1.009,0,0,0-.727.339,3.061,3.061,0,0,0-.953,2.274,5.337,5.337,0,0,0,1.11,2.819,12.173,12.173,0,0,0,4.655,4.115,5.33,5.33,0,0,0,3.271.683,2.79,2.79,0,0,0,1.837-1.3,2.278,2.278,0,0,0,.157-1.3C16.417,15.637,16.235,15.568,15.965,15.435Z",
    transform: "translate(0.711 -1.75)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappOutline);
export default __webpack_public_path__ + "static/media/whatsapp-outline.3c727860b172a788184aa819c1e01d57.svg";
export { ForwardRef as ReactComponent };